import {
  BarChart3,
  Bell,
  LayoutDashboard,
  LayoutGrid,
  Inbox,
  Users,
  MapPin,
  Briefcase,
  CalendarRange,
  FileText,
  KanbanSquare,
  Target,
  Repeat,
  Ruler,
  Activity,
  Box,
  ArrowDownCircle,
  ArrowUpCircle,
  Receipt,
  MessageCircle,
  ClipboardCheck,
  ShieldCheck,
  UserCog,
  UserCircle2,
  Wrench,
  HardHat,
  ListTodo,
  Banknote,
  Landmark,
  Linkedin,
  Wallet,
  Clock,
  Building2,
  Calculator,
  AlertTriangle,
  Siren, Gavel,
  Radar,
  FolderInput,
  BookOpen,
  FolderOpen,
  Coins,
  Globe,
  Info,
  DoorOpen,
  KeyRound,
  Mail,
  FileSpreadsheet,
  History,
  ScrollText, Webhook, Newspaper, CalendarClock, ListOrdered,
} from "lucide-react";
import { moduloDaRota, itemVisivelPelosModulos } from "../../api/lib/catalogoModulos";
export { itemVisivelPelosModulos };

// Itens de menu. Organizados em grupos com vocabulário de empresa:
// VISÃO GERAL → COMERCIAL → OPERAÇÃO → FINANCEIRO → SOCIETÁRIO → BASE → SISTEMA.
// Regula360 tem grupo próprio (GESTÃO REGULATÓRIA).
//
// 🟥 05/09 — O CAMPO `empresas` (allowlist por slug) MORREU. 46 itens tinham uma lista
// de slugs que o Operador não via nem vendia. Agora TUDO que esconde tela é módulo
// (api/lib/catalogoModulos + empresas.modulos): quem decide o que cada empresa vê é o
// dado, não o código. A paridade item a item está em tests/menu-por-modulo-paridade.
//
// Fica FORA do Layout (arquivo puro, sem React) pra ser testável: o capstone da
// nav v2 (grupo PESSOAS = Pessoas·Usuários·Folha) é provado computando o grupo a
// partir DESTE dado + os helpers de pele abaixo, sem renderizar a sidebar inteira.
export const NAV = [
  // 📊 VISÃO GERAL — onde se abre o sistema pra ver o resumo
  // Regula v2: a HOME da Regula passou a ser a TORRE (ver DashboardSwitcher no App.tsx).
  // Se "Painel" continuasse aqui sem escopo, o operador da Regula veria DOIS itens
  // levando à mesma tela. Então ele fica com as empresas de facilities, e a Regula
  // ⚰️ 18/08 — "Painel da operação" (/painel-regula) morreu de vez na Onda 3:
  // tinha zero abertura registrada num instrumento que gravou 23 rotas no mesmo
  // dia. A curva de 12 meses mudou pro Faturamento (ao lado da projeção) e as
  // duas promessas restantes — "Carteira por cliente" e o placar Boletos/Motor —
  // migraram pra Torre (components/torre/, tests/gestao-a-vista.test.ts). Rota e
  // arquivo não existem mais.
  { to: "/", label: "Painel", icon: LayoutDashboard, roles: ["admin", "encarregado"], grupo: "VISÃO GERAL" },
  // 🔝 A TORRE ABRE O MENU DA REGULA (decisão do dono, 24/08). Ela é a home do
  // operador Regula — estar abaixo da inbox do grupo fazia a tela mais importante
  // ser a segunda. No M5 a Torre não renderiza, então a ordem de lá não muda.
  // 32§6-12 (frente C, 13/10): o encarregado ganha a porta. As leituras da Torre já aceitavam admin+encarregado; só o
  // gerar/aprovar/enviar do relatório mensal é do admin (RelatoriosDoMes esconde os botões para quem não pode).
  { to: "/portfolio", label: "Torre de Controle", icon: Building2, roles: ["admin", "encarregado"], grupo: "VISÃO GERAL" },
  // "Precisa de você" — a inbox da Duda (mesma fila do radar, 3 vistas). Redesign v2:
  // só aparece sob ?skin=v2 (soV2), pra a v1 ficar byte-idêntica. Rota sempre viva (deep-link).
  // 🟥 NO REGULA ELE SE CHAMA "DUDA" (decisão do dono, 24/08): a Torre tem uma SEÇÃO
  // chamada "Precisa de você" (a fila que trava dinheiro da carteira) e o menu tinha um
  // item de MESMO NOME com outro conteúdo — a caixa do GRUPO, com outra contagem (70 × 35).
  // Dois nomes iguais pra coisas diferentes na mesma tela é confusão garantida. O rótulo
  // muda SÓ na Regula (labelPorEmpresa) — no M5 não há colisão e o nome fica byte-idêntico.
  { to: "/precisa-de-voce", label: "Precisa de você", labelPorEmpresa: { regula360: "Duda", "vitrine-reg": "Duda" } as Record<string, string>, icon: Inbox, roles: ["admin", "encarregado"], grupo: "VISÃO GERAL", soV2: true },
  // "Portal do cliente" saiu da sidebar: a lente "Ver como → Cliente" é o preview
  // real e escopado; a rota /portal-regula segue viva pra deep-link.
  { to: "/bi-site", label: "Indicadores do Site", icon: Globe, roles: ["admin"], grupo: "VISÃO GERAL" },
  { to: "/repositorio", label: "Repositório", icon: FolderOpen, roles: ["admin", "encarregado"], grupo: "RECURSOS" },
  { to: "/comunicacao", label: "Agenda & E-mail", icon: Mail, roles: ["admin"], grupo: "COMUNICAÇÃO" },
  { to: "/whatsapp", label: "WhatsApp", icon: MessageCircle, roles: ["admin", "encarregado"], grupo: "COMUNICAÇÃO" },
  { to: "/portal", label: "Meu Painel", icon: LayoutDashboard, roles: ["cliente"], grupo: "VISÃO GERAL" },
  // Self-service do dono do cliente: gerenciar a própria equipe. Só aparece pro dono (donoOnly).
  { to: "/equipe", label: "Equipe", icon: Users, roles: ["admin", "cliente"], grupo: "PESSOAS", donoOnly: true },

  // 🩺 DIAGNÓSTICO & MONITORAMENTO — pilar 1 do Regula (mede a "saúde regulatória")
  // Ordem = jornada da unidade: cadastra (Unidades) → prepara/onboarding (Implantação) → acompanha (Documentos/gestão à vista).
  // 🏬 CARTEIRA — o cadastro-base que TODOS os pilares consomem (auditoria e boletos
  // também leem unidade). Ficava dentro de Diagnóstico, mas a própria tela de Unidades
  // abre escrita "AUDITORIA" no topo: o menu e a página discordavam. Grupo próprio
  // resolve os dois — e a jornada fica cadastra (Unidades) → prepara (Implantação).
  { to: "/centros", label: "Unidades", icon: Building2, roles: ["admin", "encarregado"], grupo: "CARTEIRA", pilar: "diagnostico" },
  { to: "/onboarding-regula", label: "Implantação", icon: ClipboardCheck, roles: ["admin", "encarregado"], grupo: "CARTEIRA", pilar: "diagnostico" },
  { to: "/mesa-revisao", label: "Mesa de Revisão", icon: ScrollText, roles: ["admin", "encarregado"], grupo: "DIAGNÓSTICO & MONITORAMENTO", pilar: "diagnostico" },
  { to: "/a-confirmar", label: "A confirmar", icon: Inbox, roles: ["admin", "encarregado"], grupo: "DIAGNÓSTICO & MONITORAMENTO", pilar: "diagnostico" }, // 28/10: o balde dos tipos que a IA chutou com pouca certeza
  { to: "/documentos-regula", label: "Documentos", icon: FileText, roles: ["admin", "encarregado", "cliente"], grupo: "DIAGNÓSTICO & MONITORAMENTO", pilar: "diagnostico" },
  { to: "/requisitos-conformidade", label: "Requisitos", icon: ShieldCheck, roles: ["admin", "encarregado"], grupo: "DIAGNÓSTICO & MONITORAMENTO", pilar: "diagnostico" },
  // Atalhos consolidados do PORTAL (todas as unidades num lugar).
  // 🔴 VENCIMENTOS GANHOU PORTA PRO OPERADOR (24/08). A tela é a lista mais acionável do
  // pilar — ordenada pelo prazo de TRÂMITE, não pela data do papel — e os KPIs da Torre e
  // de Documentos já apontavam pra ela (`/portal-vencimentos?st=…`). Só que ela não tinha
  // ENTRADA no menu do operador: só se chegava clicando num número. Tela viva sem porta é
  // tela que só quem já sabe do caminho usa. A rota nunca foi só-cliente (clienteRedirect=false).
  { to: "/portal-vencimentos", label: "Vencimentos", icon: Clock, roles: ["admin", "encarregado", "cliente"], grupo: "DIAGNÓSTICO & MONITORAMENTO", pilar: "diagnostico" },
  // 📅 07 (pacote de mocks 2, aprovado 14/10): quanto se gasta com renovação em cada um dos próximos 12 meses. Logo abaixo de
  // Vencimentos (a mesma família: o que vence → quanto custa renovar). 👑 14/10: o cliente vê o DELE, em modo leitura.
  { to: "/renovacoes-calendario", label: "Calendário de renovações", icon: CalendarClock, roles: ["admin", "encarregado", "cliente"], grupo: "DIAGNÓSTICO & MONITORAMENTO", pilar: "diagnostico" },
  // "Comparar unidades" é a gestão à vista da carteira DELE — o gestor de 100
  // prédios abre isto toda segunda. Só papel cliente: o operador tem a mesma
  // leitura (e mais) em /documentos-regula, que já é dele.
  // 🏛️ mock 13 do pacote 2 (14/10): o Painel do board — a tela do DECISOR (o servidor recusa quem não decide, com o motivo).
  { to: "/portal-board", label: "Painel do board", icon: Landmark, roles: ["cliente"], grupo: "DIAGNÓSTICO & MONITORAMENTO", pilar: "diagnostico" },
  { to: "/portal-comparar", label: "Comparar unidades", icon: BarChart3, roles: ["cliente"], grupo: "DIAGNÓSTICO & MONITORAMENTO", pilar: "diagnostico" },
  // 📰 32§6-12 (frente C, 13/10): "O que mudou para você" existia desde 06/09 e só se chegava pela home. Mesma régua do
  // Vencimentos: tela viva sem porta é tela que só quem já sabe do caminho usa. Só cliente (o operador tem a Biblioteca).
  { to: "/portal-o-que-mudou", label: "O que mudou", icon: Newspaper, roles: ["cliente"], grupo: "DIAGNÓSTICO & MONITORAMENTO", pilar: "diagnostico" },
  // 🛡️ Carteira para a seguradora (mock 03 do pacote 2, 14/10): a nota documental por unidade e o papel congelado. O
  // operador gera o papel; o cliente lê a nota das unidades dele (decisão do dono 14/10: modo leitura). Pilar-base.
  { to: "/carteira-seguradora", label: "Carteira para a seguradora", icon: ShieldCheck, roles: ["admin", "encarregado", "cliente"], grupo: "DIAGNÓSTICO & MONITORAMENTO", pilar: "diagnostico" },
  // 🌱 ESG da carteira (mock 45 seção 2, aprovado 14/10): Ambiental, Social e Governança do acervo e das contas. 👑 operador E cliente (escopo dele).
  { to: "/esg-regula", label: "ESG", icon: Globe, roles: ["admin", "encarregado", "cliente"], grupo: "DIAGNÓSTICO & MONITORAMENTO", pilar: "diagnostico" },
  // Biblioteca = base legal TRANSVERSAL (todos os pilares + M5) → grupo RECURSOS (junto do Repositório), não sob o pilar Diagnóstico.
  { to: "/biblioteca", label: "Biblioteca", icon: BookOpen, roles: ["admin", "encarregado"], grupo: "RECURSOS" },
  // 🧭 10 (pacote de mocks 2, aprovado 14/10): o editor de roteiros de renovação (rascunho × em uso × histórico). Em RECURSOS,
  // como no mock, mas no módulo `diagnostico` (o pilar-base da Regula): quem não tem o pilar não vê.
  { to: "/roteiros-renovacao", label: "Roteiros de renovação", icon: ListOrdered, roles: ["admin", "encarregado"], grupo: "RECURSOS", pilar: "diagnostico" },
  // 📊 LinkedIn da Regula (mock 12, 10/10): a página Regula360 no LinkedIn, só a fatia dela. Módulo `linkedin`, ligado só na regula360.
  { to: "/linkedin-regula", label: "LinkedIn", icon: Linkedin, roles: ["admin", "encarregado"], grupo: "RECURSOS" },
  // 🔎 AUDITORIA E RECUPERAÇÃO — pilar 3 (achados retroativos → success fee)
  // Trilha do pilar Auditoria: Fontes (entram os docs) → [Varredura IA] → Achados (saída).
  { to: "/fontes-auditoria", label: "Fontes", icon: FolderInput, roles: ["admin", "encarregado"], grupo: "AUDITORIA E RECUPERAÇÃO", pilar: "auditoria" },
  { to: "/achados", label: "Achados", icon: AlertTriangle, roles: ["admin", "encarregado"], grupo: "AUDITORIA E RECUPERAÇÃO", pilar: "auditoria" },
  // 🚨 Risco de interdição (D5, mock 13, 10/10): quem seria interditada amanhã. Abaixo de Achados, no mesmo módulo `auditoria`.
  { to: "/risco-interdicao", label: "Risco de interdição", icon: Siren, roles: ["admin", "encarregado"], grupo: "AUDITORIA E RECUPERAÇÃO", pilar: "auditoria" },
  // ⚖️ Autos de infração (D8, mock 14, 11/10): que autos chegaram, quanto custa cada um e até quando defendemos. Abaixo de Risco de interdição, no mesmo módulo `auditoria`.
  { to: "/autos-infracao", label: "Autos de infração", icon: Gavel, roles: ["admin", "encarregado"], grupo: "AUDITORIA E RECUPERAÇÃO", pilar: "auditoria" },
  // 📜 Auditoria do contrato de locação (D9, mock 15, 11/10): o que o contrato diz × o que foi cobrado. Mesmo módulo `auditoria`.
  { to: "/auditoria-do-contrato", label: "Auditoria do contrato", icon: ScrollText, roles: ["admin", "encarregado"], grupo: "AUDITORIA E RECUPERAÇÃO", pilar: "auditoria" },
  // 📡 Radar da reforma tributária (D10, mock 16, 11/10): quanto o rateio muda com a reforma e se o repasse está certo. Termina em achado e carta, como as vizinhas.
  { to: "/radar-reforma", label: "Radar da reforma tributária", icon: Radar, roles: ["admin", "encarregado"], grupo: "AUDITORIA E RECUPERAÇÃO", pilar: "auditoria" },
  { to: "/portal-economia", label: "Economia & Achados", icon: Coins, roles: ["cliente"], grupo: "AUDITORIA E RECUPERAÇÃO", pilar: "auditoria" },
  // 🧾 AUDITORIA DE BOLETOS — pilar 4 (recorrente), GRUPO PRÓPRIO (não é o mesmo pilar
  // da Auditoria & Recuperação retroativa). Um cliente pode contratar SÓ este.
  // B11 (S4): o operador ganha as duas portas do pilar. "Central de Boletos" = a fila de vereditos (antes só
  // dentro da Torre). A MESMA rota do cliente (/portal-boletos) vira "Gate de pagamento" para admin/encarregado
  // (labelPorPapel): é onde se decide pagar, contestar ou reter. Uma rota, um item, o nome certo para cada papel.
  { to: "/central-boletos", label: "Central de Boletos", icon: Receipt, roles: ["admin", "encarregado"], grupo: "AUDITORIA DE BOLETOS", pilar: "boletos" },
  { to: "/portal-boletos", label: "Auditoria de Boletos", labelPorPapel: { admin: "Gate de pagamento", encarregado: "Gate de pagamento" } as Record<string, string>, icon: Receipt, roles: ["cliente", "admin", "encarregado"], grupo: "AUDITORIA DE BOLETOS", pilar: "boletos" },
  // 🔧 REGULARIZAÇÃO (pilar 2) entra quando o módulo for construído.

  // 🤝 COMERCIAL — ordem = jornada de venda: prospecta → capta (Funil) → propõe (Simulador) →
  // vira cliente → fecha contrato → expande (Cobertura).
  // 🎯 12/09 — mock aprovado depois de 30 rodadas. 👑 13/09: módulo próprio `prospeccao` (só M5 e Regula360
  // ligam) e ANTES do Funil ("prospeccao nao deveria vir antes de funil?"). O banco fecha de novo: a base
  // só abre para admin com a M5 ou a Regula ativa.
  { to: "/prospeccao", label: "Prospecção", icon: Target, roles: ["admin"], grupo: "COMERCIAL" },
  { to: "/pipeline", label: "Funil (Oportunidades)", icon: KanbanSquare, roles: ["admin"], grupo: "COMERCIAL" },
  { to: "/simulador-proposta", label: "Simulador de proposta", icon: Calculator, roles: ["admin"], grupo: "COMERCIAL" },
  { to: "/clientes", label: "Clientes", icon: Users, roles: ["admin", "encarregado"], grupo: "COMERCIAL" },
  // 🗺️ 30/08 — o mapa nasce só na M5: é a carteira DELA (contrato, pontual,
  // obra, lead) que ele desenha. Regula e Átomo têm farol documental próprio.
  { to: "/mapa-da-carteira", label: "Mapa da carteira", icon: MapPin, roles: ["admin"], grupo: "COMERCIAL" },
  // Orçamentos = modelo obra (itens/BDI/material). Regula vende por pacote (Lead→Contrato), não usa esta tela.
  { to: "/orcamentos", label: "Orçamentos", icon: FileText, roles: ["admin"], grupo: "COMERCIAL" },
  { to: "/contratos", label: "Contratos", icon: Repeat, roles: ["admin"], grupo: "COMERCIAL" },
  // Matriz unidade × proposta (cross-sell). É comercial, não pilar — gerencia as 5 propostas.
  { to: "/mapa-cobertura", label: "Cobertura de propostas", icon: LayoutGrid, roles: ["admin", "encarregado"], grupo: "COMERCIAL" },

  // 🔧 OPERAÇÃO — execução da obra/serviço (M5-only: Regula não faz obra)
  { to: "/obras", label: "Obras / OS", icon: Briefcase, roles: ["admin", "encarregado", "cliente"], grupo: "OPERAÇÃO" },
  { to: "/cronograma", label: "Cronograma", icon: CalendarRange, roles: ["admin", "encarregado"], grupo: "OPERAÇÃO" },
  { to: "/medicoes", label: "Medições", icon: Ruler, roles: ["admin", "cliente"], grupo: "OPERAÇÃO" },
  { to: "/saude-manutencao", label: "Saúde da Manutenção", icon: Activity, roles: ["admin", "encarregado"], grupo: "OPERAÇÃO" },
  // 10/07 — ligado. Backend, tela e rota já existiam; só o menu escondia. Os
  // modelos foram semeados no Átomo antes (migration 202607101027), senão o
  // Marcos abriria a tela vazia.
  { to: "/checklists", label: "Checklists", icon: ClipboardCheck, roles: ["admin", "encarregado"], grupo: "OPERAÇÃO" },

  // 👥 PESSOAS & EQUIPE — quadro, documentos (NR/ASO), liberação de acesso, folha.
  // Redesign v2 (capstone do módulo Equipe): sob ?skin=v2 o grupo vira
  // Pessoas·Controle de Acesso·Usuários·Folha. As 3 telas redesenhadas trocam de
  // página e de rótulo; o Controle de Acesso NÃO foi absorvido e continua nas duas
  // peles (ver o comentário dele abaixo). Na v1 o grupo fica BYTE-IDÊNTICO.
  // Ver itemVisivelNaSkin/rotuloItem abaixo.
  { to: "/colaboradores", label: "Colaboradores", labelV2: "Pessoas", icon: Users, roles: ["admin", "encarregado"], grupo: "PESSOAS" },
  // 🔴 O `soV1` daqui CAIU (auditoria do flip do Átomo, 28/07). Ele dizia que
  // "Usuários absorveu o Controle de Acesso" — e não absorveu: `UsuariosV2` trata
  // LOGIN (convite, papel, acesso ao sistema, /usuarios/:id/acesso); esta tela trata
  // LOCAL DE OBRA que exige credencial — /acesso/locais, /acesso/requisitos,
  // /acesso/vencimentos, endpoints sem nenhum outro chamador no cliente. Sob a v2 o
  // item sumia do menu e a tela inteira ficava sem porta; pior, o perfil `tst`
  // (whitelist em Layout.tsx) ficava com UMA tela. As duas convivem no grupo PESSOAS.
  { to: "/acesso", label: "Controle de Acesso", icon: DoorOpen, roles: ["admin", "encarregado"], grupo: "PESSOAS" },
  // Usuários & acesso — só na v2 (a v1 nunca teve este item na sidebar; entrava via
  // Sobre/Operador). Trata login/convite/papel. Guard is_owner/dono é in-page.
  { to: "/usuarios", label: "Usuários", icon: KeyRound, roles: ["admin"], grupo: "PESSOAS", soV2: true },
  { to: "/folha", label: "Folha de Pagamento", labelV2: "Folha", icon: UserCog, roles: ["admin"], grupo: "PESSOAS" },
  { to: "/rh", label: "Ponto", icon: Clock, roles: ["admin"], grupo: "PESSOAS", inativo: true },

  // 📦 RECURSOS — insumos, parceiros e ferramentas (+ Repositório/Biblioteca abaixo).
  // "Estoque & Compras" saiu do menu em 14/07 (auditoria de Recursos): ZERO linhas nas três
  // tabelas, desde sempre. Ficava no balde "EM BREVE" — e "em breve" há meses não é promessa,
  // é mentira educada. Desenho de como voltar direito: docs/ADR-004-estoque-compras.md.
  { to: "/prestadores", label: "Prestadores", icon: HardHat, roles: ["admin", "encarregado"], grupo: "RECURSOS" },
  { to: "/ativos", label: "Ferramentas", icon: Box, roles: ["admin", "encarregado"], grupo: "RECURSOS" },

  // 💰 FINANCEIRO — dinheiro entrando, saindo e fechando. No Regula só "Faturamento"
  // (success fee); o resto é detalhe financeiro do M5 (escondido pro Regula).
  // "Painel do dinheiro" — só v2 (na v1 o banco vive nas abas do Fiscal). Recebe a
  // Conciliação + Contas bancárias que saíram do Fiscal na reorg "só governo".
  { to: "/painel-dinheiro", label: "Painel do dinheiro", icon: Landmark, roles: ["admin"], grupo: "FINANCEIRO", soV2: true },
  { to: "/contas-receber", label: "A Receber", icon: ArrowDownCircle, roles: ["admin"], grupo: "FINANCEIRO" },
  { to: "/contas-pagar", label: "A Pagar", icon: ArrowUpCircle, roles: ["admin"], grupo: "FINANCEIRO" },
  // "Manda um documento" (/documentos) SAIU do menu (reorg Financeiro, 15/07) — é
  // função, não área. Virou botão em Contas a Pagar (admin, é lá que nasce a conta a
  // pagar) e em Obras/OS (encarregado, manda a nota do campo). A rota /documentos
  // continua viva com o gate próprio dela — sem esse cuidado o encarregado, cujo ÚNICO
  // acesso ao Financeiro era este item, perderia a função. Ver m5_financeiro_reorg_planta_especialistas.
  // "Lançamentos" (/ledger) VOLTOU ao menu (decisão do dono, 25/07). Na reorg 9→6 ela tinha saído
  // pra ser só o "Livro" detrás de Sócios — mas é ONDE o dinheiro real é lançado, e tela escondida
  // atrás de outra tela não é caminho, é sorte. Volta como área, entre A Pagar e Resultado, com o
  // nome que diz o que ela faz. Os atalhos ("Lançar gasto do bolso" em A Pagar e o link em Sócios)
  // seguem vivos como portas extras — mais de um caminho pra mesma tela é bom, escondê-la não era.
  { to: "/ledger", label: "Lançamentos", icon: Wallet, roles: ["admin"], grupo: "FINANCEIRO" },
  // "Custo por Cliente" (/custo-por-cliente) SAIU do menu: virou DRILL dentro do Resultado (link em
  // Fechamento). É relatório, não área. Rota viva.
  // "Vencimentos" SAIU do menu (reorg 9→6): virou ABA "Recorrentes" dentro de A Pagar — é conta
  // a pagar recorrente. Lê a mesma tabela `vencimentos` (nada migra; a Duda não quebra). A rota
  // /vencimentos continua viva (bookmark/deep-link). Ver m5_financeiro_reorg_planta_especialistas.
  { to: "/faturamento-regula", label: "Faturamento", icon: Banknote, roles: ["admin"], grupo: "FINANCEIRO" },
  { to: "/fechamento", label: "Resultado", icon: FileSpreadsheet, roles: ["admin"], grupo: "FINANCEIRO" },
  { to: "/fiscal", label: "Fiscal", icon: Receipt, roles: ["admin"], grupo: "FINANCEIRO" },
  // 📒 O RAZÃO — a fonte única do dinheiro (F3 do Trilho). Mock aprovado pelo dono 03/09 14:15: item próprio,
  // por último no grupo (é a base, não a tela do dia a dia), só admin — igual ao Painel do dinheiro.
  { to: "/razao", label: "Razão", icon: BookOpen, roles: ["admin"], grupo: "FINANCEIRO" },
  // 🏦 CONCILIAÇÃO — a porta canônica. 👑 12/09: o aceite passou (setembro fechou 20 de 20, saldo batendo) e ele
  // mandou trocar; "/conciliacao" abre a CONCILIAÇÃO EM UMA LISTA e o item temporário "Conciliação em lista" saiu.
  //
  // 🟥 E AQUI EU ACHEI O QUE NÃO SABIA (o teste do catálogo pegou): "Conciliação" NUNCA teve item de menu. A tela
  // antiga só era alcançada pelo Painel do dinheiro ou digitando a URL — por isso ele navegava pelo item temporário
  // que eu tinha criado. Tirar o temporário sem pôr este deixaria a tela sem porta nenhuma no menu.
  //
  // 👑 22/09: a de dois lados FOI APAGADA. O que só existia nela veio junto: fechar o caixa virou a etapa
  // "Mês trancado" do trilho, os lotes viraram "Extratos importados", e "pago por sócio" virou uma resposta
  // na lista de documentos que o banco ainda não mostrou. "Casar seleção" (N×M) morreu: uso medido = ZERO.
  { to: "/conciliacao", label: "Conciliação", icon: Landmark, roles: ["admin"], grupo: "FINANCEIRO", soV2: true },
  // "Tributário & Empresa" (/tributario) SAIU do menu (reorg 9→6): virou ABA "Tributário & Empresa"
  // dentro de Fiscal. As duas telas fiscais viram uma área "Fiscal" ("tô em dia com o governo?").
  // A rota /tributario segue viva; ela herda o módulo "fiscal" no moduloDoItem. Ver planta.

  // 👥 SOCIETÁRIO — sócios e governança (M5; escondido pro Regula por ora)
  { to: "/socios", label: "Sócios", icon: UserCircle2, roles: ["admin"], grupo: "SOCIETÁRIO" },

  // 📚 BASE — dados-base que alimentam outras telas (cadastra uma vez, consulta sempre)
  { to: "/engenharia", label: "Engenharia / MO", icon: Wrench, roles: ["admin"], grupo: "BASE" },
  { to: "/catalogo-servicos", label: "Catálogo de Serviços", icon: BookOpen, roles: ["admin", "encarregado"], grupo: "BASE" },
  { to: "/plano-acoes", label: "Plano de Ações", icon: ListTodo, roles: ["admin"], grupo: "BASE" },

  // ⚙️ SISTEMA — administração do painel
  { to: "/mensagens", label: "Mensagens", icon: MessageCircle, roles: ["admin", "encarregado"], grupo: "COMUNICAÇÃO" },
  { to: "/auditoria", label: "Auditoria", icon: History, roles: ["admin"], grupo: "SISTEMA" },
  // Preferências de push do PRÓPRIO usuário — por isso todo papel vê (o cliente
  // recebe "medição aguardando aprovação"; a tela filtra os eventos por papel).
  { to: "/notificacoes", label: "Notificações", icon: Bell, roles: ["admin", "encarregado", "cliente"], grupo: "SISTEMA" },
  // (Achado #45, auditoria 05/07): "cliente" removido dos roles — a rota /sobre é
  // `soOperador` no App.tsx (expulsa o cliente pro /portal), então o item aparecia
  // no menu do cliente mas o clique morria num redirect. Além disso, /sobre expõe
  // módulos/topologia interna do sistema — não é tela de cliente. Fica só operador.
  { to: "/sobre", label: "Sobre o sistema", icon: Info, roles: ["admin", "encarregado"], grupo: "SISTEMA" },
  // 📡 API e integrações (D12, 11/10): chaves de leitura e webhooks assinados da API pública da Regula. Só admin; módulo `diagnostico` (só a Regula tem).
  { to: "/api-integracoes", label: "API e integrações", icon: Webhook, roles: ["admin"], grupo: "SISTEMA", pilar: "diagnostico" },
] as const;

/**
 * Redesign v2 — a NAV é ÚNICA nas duas peles; estes helpers resolvem as
 * diferenças PONTUAIS de um item entre v1 e v2 sem duplicar linhas do NAV:
 *
 *   soV2    → item ADITIVO: só aparece quando a pele v2 está ligada (v1 idêntica).
 *   soV1    → item que MORRE na v2: a tela nova o absorveu (some sob v2).
 *   labelV2 → mesmo item/rota, rótulo diferente sob a pele nova.
 *
 * Fora esses três campos, o item é byte-idêntico nas duas peles. É por aqui que
 * o grupo PESSOAS vira Pessoas·Controle de Acesso·Usuários·Folha na v2 e volta a
 * Colaboradores·Controle de Acesso·Folha de Pagamento na v1.
 *
 * ⚠️ `soV1` hoje NÃO tem nenhum item — o único que o usava era o Controle de Acesso,
 * e a premissa estava errada (auditoria do flip do Átomo, 28/07). O campo continua
 * suportado e testado, mas antes de marcar um item com ele: some do menu ≠ absorvido.
 * Prove que a tela v2 chama os MESMOS endpoints, senão a v2 fecha a porta de uma
 * tela viva — e leva junto quem só tinha aquela porta (ver a whitelist do perfil
 * `tst` em Layout.tsx).
 */
export function itemVisivelNaSkin(item: { soV2?: boolean; soV1?: boolean }, skinV2: boolean): boolean {
  if (item.soV2 && !skinV2) return false;
  if (item.soV1 && skinV2) return false;
  return true;
}

export function rotuloItem(
  item: { label: string; labelV2?: string; labelPorEmpresa?: Record<string, string>; labelPorPapel?: Record<string, string> },
  skinV2: boolean,
  empresaSlug?: string,
  papel?: string,
): string {
  // Rótulo por EMPRESA vence os demais: ele existe pra resolver colisão de nome
  // DENTRO de um tenant (ex.: "Duda" no Regula, onde a Torre já tem uma seção
  // "Precisa de você"). Sem slug, o comportamento é o de antes — byte-idêntico.
  const porEmpresa = empresaSlug ? item.labelPorEmpresa?.[empresaSlug] : undefined;
  if (porEmpresa) return porEmpresa;
  // Rótulo por PAPEL (B11): a mesma rota se chama diferente para quem decide (operador) e para quem recebe (cliente).
  const porPapel = papel ? item.labelPorPapel?.[papel] : undefined;
  if (porPapel) return porPapel;
  return skinV2 && item.labelV2 ? item.labelV2 : item.label;
}

// ============================================================================
// RBAC MODELO DIRETO — módulo de cada item + grant usuário×módulo/item
// ============================================================================
// Fonte ÚNICA do agrupamento por módulo. Vive aqui (arquivo puro) pra o MENU
// (Layout) e a tela de ACESSOS (matriz + drill) usarem o MESMO mapa, sem
// duplicar. `moduloDoItem` era do Layout; mudou pra cá pra ser testável e
// compartilhado. `areaDoItem` continua no Layout (só o menu consome).

// Módulo (control plane) ao qual cada item pertence. O Operador liga/desliga
// `empresas.modulos[modulo]` (nível 1 = empresa contrata); o grant do usuário
// (`empresa_users.modulos`, nível 2) diz quais desses ELE vê. Retorna null =
// item de NÚCLEO, sempre visível (Painel, Repositório, Sócios…) — não entra na
// allow-list do grant.
//
// 🟥 A LISTA SAIU DAQUI EM 21/08/2026. Este mapa era UMA de TRÊS listas de
// módulos que não batiam entre si (as outras: o botão do Operador em
// `components/operador/formatos.ts` e a adoção em `routes/operador.ts`).
// Resultado medido no banco: `boletos`, `colaboradores` e `diagnostico`
// escondiam tela e não tinham botão no painel; `estoque` era vendido e não
// escondia nada; `regularizacao` estava gravada em 5 empresas e ninguém lia.
// Agora a resposta vem de `api/lib/catalogoModulos`, e a classificação por
// GRUPO morreu junto: ela gateava tela nova sozinha, mas era invisível pro
// painel. A catraca que substitui esse automatismo está em
// `tests/catalogo-modulos-uma-lista-so` — tela nova em grupo gateado sem
// entrada no catálogo REPROVA o PR, com o nome da tela.
export function moduloDoItem(item: { to: string; grupo: string }): string | null {
  return moduloDaRota(item.to);
}

// Rótulo humano de cada módulo (pro cabeçalho das colunas da matriz de Acessos).
export const ROTULO_MODULO: Record<string, string> = {
  comercial: "Comercial",
  operacao: "Operação",
  financeiro: "Financeiro",
  fiscal: "Fiscal",
  colaboradores: "Pessoas",
  rh: "Ponto",
  estoque: "Estoque",
  bi: "Indicadores do site",
  portal: "Portal",
  diagnostico: "Diagnóstico",
  regularizacao: "Regularização",
  auditoria: "Auditoria",
  boletos: "Boletos",
  // 05/09 — os módulos que substituíram as listas por slug (nomes aprovados pelo dono)
  painel: "Painel",
  torre: "Torre",
  comunicacao: "Comunicação",
  pessoas: "Pessoas e acesso",
  societario: "Sócios",
  base: "Base técnica",
  sistema: "Sistema",
  biblioteca: "Biblioteca",
  orcamentos: "Orçamentos",
  comercial_regula: "Comercial Regula",
  mapa_carteira: "Mapa da carteira",
  faturamento: "Faturamento",
  prospeccao: "Prospecção", // 13/09 — só M5 e Regula360
  linkedin: "LinkedIn da Regula", // 10/10 — só Regula360
};
export function rotuloModulo(modulo: string): string {
  return ROTULO_MODULO[modulo] ?? modulo;
}

// GRANT do usuário nesta empresa (empresa_users.modulos). null/undefined =
// HERDA (vê tudo que a empresa contratou). Objeto = allow-list por módulo:
//   chave ausente          → não vê o módulo
//   valor true             → módulo INTEIRO
//   valor string[]         → só esses itens (granularidade item-level)
export type GrantModulos = Record<string, true | string[]> | null | undefined;

/**
 * Um item do menu está liberado pelo GRANT do usuário? (nível 2)
 * NÚCLEO (moduloDoItem null) é sempre liberado — não entra na allow-list.
 * Grant null = herda. Vale igual pra TODO módulo (fonte = moduloDoItem).
 */
export function itemLiberadoPorGrant(item: { to: string; grupo: string }, grant: GrantModulos): boolean {
  const modulo = moduloDoItem(item);
  if (!modulo) return true; // núcleo: sempre visível
  if (grant == null) return true; // herda tudo que a empresa contratou
  const g = grant[modulo];
  if (g === undefined) return false; // módulo fora da allow-list
  if (g === true) return true; // módulo inteiro
  if (Array.isArray(g)) return g.includes(item.to); // só itens listados
  return false;
}

/**
 * Agrupa os itens do menu por MÓDULO, pra a tela de Acessos montar a matriz e o
 * drill (expandir módulo → itens). Só entram itens que a empresa PODE ver:
 * módulo não-nulo (núcleo não vira coluna), pele, e módulo contratado
 * (empresas.modulos = nível 1, pela MESMA função do menu). Dedup por rota.
 * `empresaSlug` ficou na assinatura por compatibilidade (05/09): o slug não decide mais.
 */
export function modulosDoMenu(opts: {
  empresaSlug: string;
  skinV2: boolean;
  modulosContratados?: Record<string, boolean> | null;
}): Array<{ modulo: string; rotulo: string; itens: Array<{ to: string; label: string }> }> {
  const porModulo = new Map<string, Array<{ to: string; label: string }>>();
  const vistos = new Set<string>();
  for (const item of NAV) {
    const modulo = moduloDoItem(item);
    if (!modulo) continue; // núcleo não é coluna
    if (!itemVisivelPelosModulos(modulo, opts.modulosContratados)) continue; // nível 1: empresa não contratou
    if (!itemVisivelNaSkin(item as { soV2?: boolean; soV1?: boolean }, opts.skinV2)) continue;
    const chave = `${modulo}::${item.to}`;
    if (vistos.has(chave)) continue;
    vistos.add(chave);
    const arr = porModulo.get(modulo) ?? [];
    arr.push({ to: item.to, label: rotuloItem(item as { label: string; labelV2?: string }, opts.skinV2) });
    porModulo.set(modulo, arr);
  }
  return [...porModulo.entries()].map(([modulo, itens]) => ({ modulo, rotulo: rotuloModulo(modulo), itens }));
}

// ----------------------------------------------------------------------------
// Manipulação do GRANT pela tela de Acessos (matriz + drill). Tudo PURO/testável.
// A regra-mestra: grant null = "herda tudo que a empresa contratou". A UI só
// MATERIALIZA (vira allow-list explícita) quando o dono começa a restringir; e
// VOLTA pra null quando tudo está ligado de novo — pra "herda" ser a verdade.
// ----------------------------------------------------------------------------

// Estado de um módulo no grant, pro chip da matriz ("Tudo" / "N de M" / "—").
export type EstadoModulo = "todos" | "parcial" | "nenhum";
export function estadoModulo(grant: GrantModulos, modulo: string, itensDoModulo: string[]): EstadoModulo {
  if (grant == null) return "todos"; // herda
  const g = grant[modulo];
  if (g === undefined) return "nenhum";
  if (g === true) return "todos";
  const set = new Set(g);
  const cobre = itensDoModulo.filter((r) => set.has(r)).length;
  if (cobre === 0) return "nenhum";
  if (cobre >= itensDoModulo.length) return "todos";
  return "parcial";
}

// Quantos itens de um módulo estão liberados (pro chip "N de M").
export function itensLiberados(grant: GrantModulos, modulo: string, itensDoModulo: string[]): number {
  if (grant == null) return itensDoModulo.length; // herda tudo
  const g = grant[modulo];
  if (g === undefined) return 0;
  if (g === true) return itensDoModulo.length;
  const set = new Set(g);
  return itensDoModulo.filter((r) => set.has(r)).length;
}

// Materializa o grant herdado (null) num objeto explícito = todos os módulos ON.
export function materializarGrant(grant: GrantModulos, todosModulos: string[]): Record<string, true | string[]> {
  if (grant != null) return { ...grant };
  return Object.fromEntries(todosModulos.map((m) => [m, true as const]));
}

// Se o grant materializado libera TODOS os módulos inteiros (e nada além) → volta
// pra null (herda), pra "herda tudo" continuar sendo a verdade quando nada restringe.
export function normalizarGrant(g: Record<string, true | string[]>, todosModulos: string[]): GrantModulos {
  const todosOn = todosModulos.every((m) => g[m] === true);
  const semExtra = Object.keys(g).every((k) => todosModulos.includes(k));
  return todosOn && semExtra ? null : g;
}

// Liga/desliga o MÓDULO INTEIRO. Retorna o novo grant (null se voltou a herdar tudo).
export function definirModulo(
  grant: GrantModulos,
  modulo: string,
  ligar: boolean,
  todosModulos: string[]
): GrantModulos {
  const g = materializarGrant(grant, todosModulos);
  if (ligar) g[modulo] = true;
  else delete g[modulo];
  return normalizarGrant(g, todosModulos);
}

// Liga/desliga UM ITEM dentro do módulo (granularidade progressiva). Ao desligar
// um item de um módulo que estava "todos", vira "N de M". Vale pra TODO módulo.
export function definirItem(
  grant: GrantModulos,
  modulo: string,
  rota: string,
  ligar: boolean,
  itensDoModulo: string[],
  todosModulos: string[]
): GrantModulos {
  const g = materializarGrant(grant, todosModulos);
  const cur = g[modulo];
  const set = cur === true ? new Set(itensDoModulo) : cur === undefined ? new Set<string>() : new Set(cur);
  if (ligar) set.add(rota);
  else set.delete(rota);
  if (set.size === 0) delete g[modulo];
  else if (itensDoModulo.every((r) => set.has(r))) g[modulo] = true; // cobriu tudo → módulo inteiro
  else g[modulo] = [...set];
  return normalizarGrant(g, todosModulos);
}

// PAPEL por empresa (nível 3). Vocabulário canônico = role global. UI rotula.
export type Papel = "admin" | "encarregado" | "cliente";
export const ROTULO_PAPEL: Record<Papel, string> = {
  admin: "Admin",
  encarregado: "Equipe",
  cliente: "Cliente",
};
